import { Check } from "lucide-react";

export const OptionCard = ({ selected, onClick, title, desc, icon: Icon, testid, compact = false }) => (
  <button
    type="button"
    role="radio"
    aria-checked={selected}
    data-testid={testid}
    onClick={onClick}
    className={`group relative w-full text-left border transition-[border-color,background-color,transform] duration-300 focus:outline-none focus-visible:ring-1 focus-visible:ring-gold ${
      compact ? "px-4 py-3.5" : "p-5 md:p-6"
    } ${selected ? "border-gold/80 bg-gold/[0.06]" : "border-white/10 bg-white/[0.015] hover:border-white/30 hover:-translate-y-0.5"}`}
  >
    <span className={`absolute top-4 right-4 w-5 h-5 flex items-center justify-center border transition-colors duration-300 ${selected ? "border-gold bg-gold text-black" : "border-white/20 text-transparent"}`}>
      <Check size={12} strokeWidth={3} />
    </span>
    <span className={compact ? "flex items-center gap-3 sm:block" : "block"}>
      {Icon && <Icon size={compact ? 16 : 22} strokeWidth={1.4} className={`${compact ? "sm:mb-3" : "mb-4"} shrink-0 ${selected ? "text-gold" : "text-zinc-400 group-hover:text-zinc-200"} transition-colors`} />}
      <span className={`block font-heading tracking-tight pr-8 ${compact ? "text-[15px]" : "text-lg md:text-xl"} ${selected ? "text-white" : "text-zinc-100"}`}>{title}</span>
    </span>
    {desc && <span className="mt-1.5 block text-[13px] md:text-sm text-zinc-400 leading-relaxed pr-6">{desc}</span>}
  </button>
);

export const Field = ({ label, hint, error, children, htmlFor }) => (
  <div>
    <label htmlFor={htmlFor} className="flex items-baseline justify-between gap-3 mb-2 text-[12px] tracking-[0.2em] uppercase text-zinc-300">
      {label} {hint && <span className="normal-case tracking-normal text-[12px] text-zinc-500">{hint}</span>}
    </label>
    {children}
    {error && <p role="alert" data-testid={`wizard-error-${htmlFor}`} className="mt-2 text-[13px] text-red-400">{error}</p>}
  </div>
);

export const inputCls =
  "w-full bg-black/40 border border-white/15 px-4 py-3.5 text-[15px] text-white placeholder:text-zinc-600 focus:outline-none focus:border-gold transition-colors";

export const StepError = ({ text, testid }) =>
  text ? <p role="alert" data-testid={testid} className="mt-5 text-[13px] text-red-400">{text}</p> : null;

export const Progress = ({ steps, step, onJump }) => (
  <ol data-testid="wizard-progress" className="grid grid-cols-5 gap-2" aria-label="progress">
    {steps.map((s, i) => (
      <li key={s}>
        <button
          type="button"
          disabled={i >= step}
          onClick={() => onJump(i)}
          aria-current={i === step ? "step" : undefined}
          data-testid={`wizard-progress-${i}`}
          className="w-full text-left disabled:cursor-default"
        >
          <span className={`block h-px transition-colors duration-500 ${i <= step ? "bg-gold" : "bg-white/15"}`} />
          <span className={`mt-3 hidden sm:block text-[11px] tracking-[0.22em] uppercase ${i === step ? "text-gold" : i < step ? "text-zinc-300" : "text-zinc-600"}`}>
            {String(i + 1).padStart(2, "0")} · {s}
          </span>
        </button>
      </li>
    ))}
  </ol>
);
